import request from "@/http/http"
import { API } from "@/constants/config"
// import { getGeojsonByCode } from "@/api"
import { getHeatCollectionWithHash } from "@/util/heat"
// import { getAreaByGeo, getGeoHashLevelByArea } from "@/util/graphic-calc"

// 热力数据缓存
const heatMap = new Map()

// 最后一次热力数据时间
const month = "2021-08"
const Month = "2111"

/**
 * 获取人群画像报告
 */
interface GridProfileArgs {
  // 画像类型 5 常驻人口画像 15 居住人口画像 16 工作人口画像 17 访客画像
  profileType: number
  // 是否预获取数据
  prefetch?: boolean
  // 网格Id
  gridId?: string
  // 纬度
  lat?: number
  // 经度
  lon?: number
}
export async function getGridProfile(args: GridProfileArgs) {
  const { gridId, profileType, prefetch = false, lat, lon } = args
  let type = profileType

  switch (profileType) {
    case 1:
      type = 15
      break
    case 2:
      type = 16
      break
    case 3:
      type = 5
      break
    case 10:
      type = 17
      break
    default:
      break
  }
  const params =
    lat && lon
      ? {
          lat,
          lon,
          profileType: type,
        }
      : {
          gridId,
          profileType: type,
        }

  const result = await request.get(`${API}/business/grid/profile/details`, {
    params,
    cancelLoading: prefetch,
  } as any)
  return result.data
}

export interface ScenicSpotVO {
  lat: number
  lon: number
  name: string
}

export interface ConversationItemVO {
  question: string
  answer: string
}

interface ChatgptConversationArgs {
  // 名称
  name?: string
  // 纬度
  lat?: number
  // 经度
  lon?: number
  // 网格ID
  geoHash?: string
  // 查询数量
  topK?: number
  // 点位类型
  locationType?: string
}

/**
 * 获取chatgpt对话数据
 * 注：经纬度或网格ID或名称 必传其一
 */
export async function getChatgptConversation(
  args: ChatgptConversationArgs,
): Promise<ConversationItemVO[]> {
  try {
    const { lat, lon, geoHash, name, ...others } = args
    const params = name ? { name } : lat && lon ? { ...others, lat, lon } : { ...others, geoHash }
    const result = await request.post<ConversationItemVO[]>(`/business/gpt/insight`, params, {
      cancelLoading: true,
    } as any)
    return result?.data
  } catch (error) {
    throw error
  }
}

// poi热力接口
export async function getDistrictSceneHeat(district: number | string, sceneId: number | string) {
  const key = `__SCENE__${district}__${sceneId}__`
  if (heatMap.get(key)) {
    return heatMap.get(key)
  }
  try {
    const result = await request.post(`${API}/business/grid/gridHeat/district`, {
      categoryId: sceneId,
      districtCode: Number(district),
      month: Month,
    })
    heatMap.set(key, result.data)
    return result.data
  } catch (error) {}
}

// 查询区的poi数量
// regionType: [ city, district, township, neighborhood ]
export async function getRegionPoi(districtCode: number | string) {
  try {
    const result = await request.post(`${API}/business/grid/region/profile`, {
      code: districtCode,
      month: month,
      regionType: "district",
    })
    return result?.data?.poiCategoryStatistics ?? []
  } catch (error) {
    throw error
  }
}

export type GridHeatArgs = Partial<{
  // 请求区域类型 (0:城市,1:区县,2:polygon,3:CIRCLE)
  type: number
  // 人群类型 (1.居住热力, 2.工作热力,3.常驻人口热力, 5.常驻人口标签热力 10.访问人口,11.白天访问人数, 12.夜晚,13.工作日,14.周末, 15居住人口标签热力 16 工作人口标签热力，17访客人口标签热力)
  crowdType: number | string
  // 请求数据升降序 默认为true
  isAsc: boolean
  // 1-7，默认7，网格
  geoHashLevel: number
  // 城市Code
  cityCode: string
  // 区县Code
  districtCode: string | number
  // 标签code(只有人群类型选择5，15,16,17时，才有标签code)
  tag: string
  // polygon 范围 (区域类型为polygon时传值)
  range: string
  // point纬度 (区域类型为CIRCLE时传入)
  latitude: number
  // point经度 (区域类型为CIRCLE时传入)
  longitude: number
  // 半径 (区域类型为CIRCLE时传入，150<=值<=30000)
  radius: number
  // 预获取数据
  prefetch?: boolean
  // 网格数量，默认4w
  limit?: number
}>
export interface GridHeatVO {
  crowdCount: number // 人群数
  gridId: string // 网格ID
  latitude: number // point纬度
  longitude: number // point经度
}

// 查询热力数据
export async function getGridHeat(args: GridHeatArgs, prefetch = false): Promise<GridHeatVO[]> {
  const {
    tag,
    crowdType,
    // districtCode, geoHashLevel
  } = args
  let ctype = crowdType
  if (tag) {
    switch (crowdType) {
      case 1:
        ctype = 15
        break
      case 2:
        ctype = 16
        break
      case 3:
        ctype = 5
        break
      case 10:
        ctype = 17
        break
      default:
        break
    }
  }
  const defaultConfig: any = {
    type: 1,
    limit: 80000,
  }
  // 根据区县面积计算geoHashLevel
  // if (districtCode && !geoHashLevel) {
  //   const geo = await getGeojsonByCode(districtCode)
  //   const level = getGeoHashLevelByArea(getAreaByGeo(geo))
  //   defaultConfig.geoHashLevel = level
  // }
  const params = {
    ...defaultConfig,
    ...args,
    crowdType: ctype,
  }

  const result = await request.post<GridHeatVO[]>(`/business/grid/gridHeat`, params, {
    cancelLoading: prefetch,
  } as any)
  return getHeatCollectionWithHash(result.data, "oneself", 100, true, "count")
}
